import React, { useEffect } from "react";
import PremiumHeader from "./PremiumHeader";
import PremiumFooter from "./PremiumFooter";
import BackToTop from "./BackToTop";

const PremiumLayout = ({ children }) => {
  useEffect(() => {
    // Scroll animations
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll("[data-animate]").forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="premium-public-layout">
      <PremiumHeader />
      <main style={{ paddingTop: "72px" }}>{children}</main>
      <PremiumFooter />
      <BackToTop />
    </div>
  );
};

export default PremiumLayout;
